import { render } from "./border-color.vue?vue&type=template&id=53611531"
import script from "./border-color.vue?vue&type=script&lang=js"
export * from "./border-color.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__